<template>
	<div>
		<el-form :model="inputmodel" status-icon :rules="rules" ref="inputmodel" style=" display: grid;
  grid-template-columns: auto auto; grid-column-gap: 0.5rem;grid-auto-flow: row dense;">
			<el-form-item v-for="(item,index) in dialog_span" :key="index" :label="item.name" :prop="item.model">
				<el-input v-model="inputmodel[`${item.model}`]" autocomplete="off"></el-input>
			</el-form-item>
			<el-form-item label="状态" prop="status"><br>
				<el-radio v-model="inputmodel.status" label="1">有效</el-radio>
				<el-radio v-model="inputmodel.status" label="0">过期</el-radio>
			</el-form-item>

		</el-form>

		<div class="bottom_button">
			<el-button @click="qx(1)">取 消</el-button>
			<el-button type="primary" @click="qx()">确 定</el-button>
		</div>
	</div>
</template>

<script>
	import {
		clause_edit
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: '',
				dialog_span: [{
					name: '标题',
					model: 'title'
				}, {
					name: '内容',
					model: 'content'
				}],
				inputmodel: {
					title: '',
					content: '',
					status: ''
				},
				rules: {},
				options: [],
				formData: {
					page: 1,
					limit: 10,
					rent_status: 0
				},
				value2: '',
				checked: '',
				content: '',
			}
		},
		props: [
			"item"
		],
		methods: {
			qx(i) {
				console.log(this.inputmodel);
				if (i != 1) {
					this.$refs['inputmodel'].validate((valid) => {
						if (valid) {
							clause_edit(this.inputmodel).then(res => {
								this.Messages(res)
								if (res.status == 200) {
									this.inputmodel = {}
									this.$emit('changedia', false)
									this.$parent.$parent.$parent.contractlistcontractlist();
								}
							})
						}
					})
				} else {
					// this.inputmodel = {}
					this.$emit('changedia', false)
				}
			},
			loadmore() {
				console.log(this.formData.limit);
				this.formData.page++;
				let sum = this.formData.limit
				// this.formData.limit = sum - (10 * (this.formData.page - 1))
				// if (this.formData.limit >= 0) {
				this.getList(this.formData);
				// }
				// console.log(this.formData);
			},
			getList(formData) {
				house_list(formData).then(res => {
					const _res = res.data.list
					this.options = [...this.options, ..._res];
				})

			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			},
		},
		created() {
			for (let item in this.inputmodel) {
				this.rules[`${item}`] = [{
					required: true,
					message: '不能为空',
					trigger: 'blur'
				}]
			};
			this.inputmodel = JSON.parse(JSON.stringify(this.item));
			if (this.item.status == '有效') {
				this.inputmodel.status = '1'
				console.log(this.inputmodel.status);
			} else {
				this.inputmodel.status = '0'
			}
		},
		watch: {
			item: function(newVal, oldVal) {
				console.log('newVal', newVal);

				this.inputmodel = JSON.parse(JSON.stringify(this.item));
				if (this.item.status == '有效') {
					this.inputmodel.status = '1'
					console.log(this.inputmodel.status);
				} else {
					this.inputmodel.status = '0'
				}
			}
		}
	}
</script>

<style scoped>
	.bottom_button {
		margin: 20px 0;
		display: flex;
		justify-content: center;
	}

	.upload-demo {
		display: flex;
		align-items: center !important;

	}
</style>